<div [class.fullscreen-mode]="isFullScreen" [class.card]="isCustomChart" [class.mb-1]="isCustomChart"
  [style.margin-bottom]="isCustomChart ? charts?.marginBottom : null"
  [style.margin-top]="isCustomChart ? charts?.marginTop : null"
  [style.height]="isFullScreen ? '100vh' : (isCustomChart ? (charts?.cardHeight || charts?.chartConfig?.cardHeight) : null)"
  [style.border]="isCustomChart ? (charts?.chartConfig?.cardBorder || '1px solid #dee2e6') : null"
  [style.border-radius]="isCustomChart ? (charts?.chartConfig?.cardBorderRadius || '0.375rem') : null">

  <!-- Hybrid Header -->
  @if ((isFullScreen || isCustomChart) && (isFullScreen || (charts?.type !== 'generic-table' && charts?.type !== 'table-generic'))) {
  <div class="card-header" [class.card-header-black]="!isFullScreen">

    <!-- Left Section -->
    <div class="header-section left">
      @if (isFullScreen && !isTableWidget) {
      <button (click)="toggleFullScreen()" class="back-btn">
        <span class="material-icons">fullscreen_exit</span>
        <span>Back to report</span>
      </button>
      }
    </div>

    <!-- Center Section -->
    <div class="header-section center card-title">
      <h4>{{ charts?.title }}</h4>
    </div>

    <!-- Right Section: Standard actions integrated into a three-dot menu -->
    <div class="header-section right" *ngIf="charts?.type !== 'generic-table' && charts?.type !== 'table-generic'"
      style="display: flex; align-items: center; justify-content: flex-end; height: 100%;">

      <!-- Actions Menu (Three-dot) -->
      <button mat-icon-button [matMenuTriggerFor]="widgetMenu" [style.color]="isFullScreen ? '#333' : 'white'"
        title="More Actions">
        <mat-icon>more_horiz</mat-icon>
      </button>

      <!-- Fullscreen Toggle Icon -->
      <button mat-icon-button (click)="toggleFullScreen()" [style.color]="isFullScreen ? '#333' : 'white'"
        [title]="isFullScreen ? 'Exit Fullscreen' : 'Fullscreen'">
        <mat-icon>{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
      </button>

      <mat-menu #widgetMenu="matMenu">
        <!-- Download CSV Action -->
        <button mat-menu-item (click)="downloadCsv()">
          <mat-icon>file_download</mat-icon>
          <span>Export</span>
        </button>

        <!-- Drill Up: aggregate to yearly view (only when chart is in default state) -->
        @if (hasDrill && drillState === 'default') {
        <button mat-menu-item (click)="doDrillUp()">
          <mat-icon>arrow_upward</mat-icon>
          <span>Drill Up</span>
        </button>
        }

        <!-- Drill Down: reset chart back to default (only when chart has been drilled up) -->
        @if (hasDrill && drillState !== 'default') {
        <button mat-menu-item (click)="doDrillDown()">
          <mat-icon>arrow_downward</mat-icon>
          <span>Drill Down</span>
        </button>
        }

        <button mat-menu-item (click)="downloadImage('png')">
          <mat-icon>image</mat-icon>
          <span>Download as Image</span>
        </button>
      </mat-menu>
    </div>

  </div>
  }

  <div [class.card-body]="isCustomChart || isFullScreen" [class.pb-1]="isCustomChart"
    [class.p-0]="(charts?.type === 'generic-table' || charts?.type === 'table-generic') && !isFullScreen"
    [class.pt-0]="(charts?.type === 'generic-table' || charts?.type === 'table-generic') && !isFullScreen"
    [class.ps-0]="(charts?.type === 'generic-table' || charts?.type === 'table-generic') && !isFullScreen"
    [class.fullscreen-table-body]="(charts?.type === 'generic-table' || charts?.type === 'table-generic') && isFullScreen"
    [style.padding]="((charts?.type === 'generic-table' || charts?.type === 'table-generic') && !isFullScreen) ? '0 !important' : null"
    [style.height]="isFullScreen ? '100%' : (isCustomChart ? (charts?.containerHeight || charts?.height || charts?.chartConfig?.containerHeight || charts?.chartConfig?.height || 'auto') : 'auto')">

    @if (isFullScreen) {
    <button (click)="toggleFullScreen()" class="floating-close-btn" title="Exit Fullscreen">
      <span class="material-icons">close</span>
    </button>
    }

    <ng-container #chartContainer></ng-container>
  </div>
</div>
